import React from "react";
import { connect } from "react-redux";

import FooterSet from "../../libs/FooterSet";

import "./Footer.scss";

const Footer = (props) => {
  const footerContentClass = [
    "Footer__content",
    `Footer__content--${props.currentQuestion}`,
  ];

  return (
    <div className="Footer__wrapper" role="contentinfo">
      <div className={footerContentClass.join(" ")}>
        <a
          target="_blank"
          rel="noreferrer"
          href={FooterSet.copyright}
          className="Footer__link"
        >
          © 2022 Oracle
        </a>
        <span className="Footer__line"></span>
        <a
          target="_blank"
          rel="noreferrer"
          href={FooterSet.footerLink1}
          className="Footer__link"
        >
          {FooterSet.footer1}
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          id="teconsent"
          className="Footer__link"
        ></a>
        {/* <a target="_blank" rel='noreferrer' id='teconsent' className="Footer__link"></a> */}
        <a
          target="_blank"
          rel="noreferrer"
          href={FooterSet.footerLink2}
          className="Footer__link"
        >
          {FooterSet.footer2}
        </a>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentLang: state.langReducer.currentLang,
    currentQuestion: state.questionsReducer.currentQuestion,
  };
};

export default connect(mapStateToProps, null)(Footer);
